import { DecimalPipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { BudgetLabour } from 'src/app/shared/models/mano-de-obra-presupuesto';

@Component({
  selector: 'app-mano-de-obra-presupuesto',
  templateUrl: './mano-de-obra-presupuesto.component.html',
  styleUrls: ['./mano-de-obra-presupuesto.component.css'],
  providers: [DecimalPipe]
})
export class ManoDeObraPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private route: string;
  private method: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  listManoDeObraPresupuesto: BudgetLabour[] = [];

  filterDetails = new FormControl('0');
  descriptionFilter = new FormControl({ value: '', disabled: true });
  descriptionSearch = new FormControl({ value: '', disabled: false });
  filterDictionary = new Map<string | null, string | null>();
  filterValue: string;

  dataSourceFilters = new MatTableDataSource<BudgetLabour>;
  displayedColumns: string[] = ['reference', 'description', 'jornal', 'bono', 'labourGrouping'];
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public pBudgetId: number,
    public dialogManoObraPresupuestoRef: MatDialogRef<ManoDeObraPresupuestoComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService
  ) { }

  ngOnInit() {
    this.loadListLabourBudget();
    this.dataSourceFilters.filterPredicate = function (record, filter) {
      var map = new Map(JSON.parse(filter));
      let isMatch = false;
      for (let [key, value] of map) {
        if (key as keyof BudgetLabour === 'description') {
          isMatch = (record.description || '').trim().toLowerCase().indexOf(value as keyof BudgetLabour) !== -1;
        } else if (key as keyof BudgetLabour === 'reference') {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof BudgetLabour) !== -1;
        } else if (key === "0") {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof BudgetLabour) !== -1
            || (record.description || '').trim().toLowerCase().indexOf(value as keyof BudgetLabour) !== -1
            || String(record.jornal).toString().indexOf(value as keyof BudgetLabour) !== -1
            || String(record.bono).toString().indexOf(value as keyof BudgetLabour) !== -1
            || (record.labourGrouping || '').trim().toLowerCase().indexOf(value as keyof BudgetLabour) !== -1

        } else if (value === '') {
          isMatch = true;
        };
        if (!isMatch) return false;
      }
      return isMatch;
    };
  }

  ngAfterViewInit() {
    this.dataSourceFilters.sort = this.sort;
  }

  loadListLabourBudget() {
    this.route = '/getLaborByBudgetLineItem';
    this.method = 'POST';
    let data = {
      idBudget: this.pBudgetId
    };
    this.listManoDeObraPresupuesto = [];

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          for (let [i, labourResponse] of response.data.entries()) {
            let labour: BudgetLabour = {
              reference: labourResponse.reference,
              description: labourResponse.descriptionLabor,
              jornal: labourResponse.jornalBs,
              bono: labourResponse.bonusBs,
              labourGrouping: labourResponse.groupLabor
            };
            this.listManoDeObraPresupuesto.push(labour);
          }
          this.dataSourceFilters.data = this.listManoDeObraPresupuesto;
          this.apiCallService.hideSpinner();
        } else {
          this.closeDialogManoObraPresupuesto();
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
      });
  }

  cleanFilter() {
    this.descriptionFilter.setValue('');
    this.descriptionSearch.setValue('');
    if (this.filterDetails.value === '0') {
      this.descriptionFilter.disable();
      this.descriptionSearch.enable();
    } else {
      this.descriptionFilter.enable();
      this.descriptionSearch.disable();
    }
  }

  applyFilterDetails(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    this.filterDictionary.set(this.filterDetails.value, this.filterValue);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.dataSourceFilters.filter = jsonString;

    if (this.dataSourceFilters.paginator) {
      this.dataSourceFilters.paginator.firstPage();
    }
  }

  closeDialogManoObraPresupuesto() {
    this.dialogManoObraPresupuestoRef.close();
  }

}
